import { render, staticRenderFns } from "./edit-campana-campo.vue?vue&type=template&id=cc918836"
import script from "./edit-campana-campo.vue?vue&type=script&lang=ts"
export * from "./edit-campana-campo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports